export default __webpack_public_path__ + "media/zurb/img/case-study-paysa/paysa-sketches-e45d48a6b50219a05857a59eac10eda5.png";